module.exports = __webpack_public_path__ + "fe0019a2448c9fd3ece66c79a7224019.svg";